import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

// pages importing
import StudentPage from "../pages/studentPage/_index";
import StudentQuestionPage from "../pages/studentQuestionPage/_index";

import ParrentPage from "../pages/parrentPage/_index";
import ParrentQuestionPage from "../pages/parrentQuestionPage/_index";

import ConfirmPage from "../pages/confirmPage/_index";
import ResultPage from "../pages/resultPage/_index";

const Router = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/student" />} />

        <Route path="/student" element={<StudentPage />} />
        <Route path="/student/question" element={<StudentQuestionPage />} />

        <Route path="/parrent" element={<ParrentPage />} />
        <Route path="/parrent/question" element={<ParrentQuestionPage />} />

        <Route path="/confirm" element={<ConfirmPage />} />
        <Route path="/result" element={<ResultPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router;
